import { render, staticRenderFns } from "./PrintLayout.vue?vue&type=template&id=36c25f6f"
import script from "./PrintLayout.vue?vue&type=script&lang=js"
export * from "./PrintLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports